/**
 * Popover
 * @requires https://getbootstrap.com
 * @requires https://popper.js.org/
 */

(function () {
  function initPopovers() {
    const popoverTriggerList = document.querySelectorAll(
      '[data-bs-toggle="popover"]'
    )

    /* eslint-disable no-unused-vars, no-undef */
    const popoverList = [...popoverTriggerList].map(
      (popoverTriggerEl) => new bootstrap.Popover(popoverTriggerEl)
    )
    /* eslint-enable no-unused-vars, no-undef */
  }

  document.addEventListener('turbo:load', initPopovers)
})()
